import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import humanTime from 'flarum/common/helpers/humanTime';
import FeedbackUserDisplay from './FeedbackUserDisplay';
export default class FeedbackItem extends Component {
  loading = false;
  view() {
    const {
      feedback,
      includedUsers,
      onDelete,
      onReport
    } = this.attrs;
    const attrs = feedback.attributes;
    const fromUserRelationship = feedback.relationships?.fromUser?.data;
    const fromUserId = fromUserRelationship?.id || attrs.fromUserId;
    const feedbackDate = new Date(attrs.createdAt);
    return m("div", {
      className: `FeedbackItem FeedbackItem--${attrs.type}`
    }, m("div", {
      className: "FeedbackItem-header"
    }, m("div", {
      className: "FeedbackItem-headerLeft"
    }, FeedbackUserDisplay.view({
      userId: fromUserId,
      includedUsers: includedUsers
    }), this.renderTypeBadge(attrs.type), this.renderRoleBadge(attrs.role)), m("div", {
      className: "FeedbackItem-headerRight"
    }, m("span", {
      className: "FeedbackItem-date"
    }, humanTime(feedbackDate)), this.renderDiscussionLink(attrs))), m("div", {
      className: "FeedbackItem-comment"
    }, attrs.comment || app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.no_comment')), this.renderActions(feedback, fromUserId));
  }
  renderTypeBadge(type) {
    const icons = {
      positive: 'fas fa-thumbs-up',
      neutral: 'fas fa-minus',
      negative: 'fas fa-thumbs-down'
    };
    const text = app.translator.trans(`huseyinfiliz-traderfeedback.forum.form.type_${type}`);
    return m("span", {
      className: `FeedbackItem-type FeedbackItem-type--${type}`
    }, m(Icon, {
      name: icons[type],
      className: "FeedbackItem-typeIcon"
    }), m("span", {
      className: "FeedbackItem-typeText"
    }, text));
  }
  renderRoleBadge(role) {
    const icons = {
      buyer: 'fas fa-cart-shopping',
      seller: 'fas fa-store',
      trader: 'fas fa-right-left'
    };
    const text = app.translator.trans(`huseyinfiliz-traderfeedback.forum.feedback_item.as_${role}`);
    return m("span", {
      className: "FeedbackItem-role"
    }, m(Icon, {
      name: icons[role],
      className: "FeedbackItem-roleIcon"
    }), m("span", {
      className: "FeedbackItem-roleText"
    }, text));
  }
  renderDiscussionLink(attrs) {
    if (!attrs.discussionId) {
      return null;
    }
    if (attrs.discussionExists === false) {
      return m("span", {
        className: "FeedbackItem-discussionLink FeedbackItem-discussionLink--deleted"
      }, m(Icon, {
        name: "fas fa-link-slash"
      }));
    }
    if (attrs.canViewDiscussion === false) {
      return m("span", {
        className: "FeedbackItem-discussionLink FeedbackItem-discussionLink--locked"
      }, m(Icon, {
        name: "fas fa-lock"
      }));
    }
    return m("a", {
      href: app.route('discussion', {
        id: attrs.discussionId
      }),
      className: "FeedbackItem-discussionLink",
      target: "_blank",
      rel: "noopener noreferrer"
    }, m(Icon, {
      name: "fas fa-arrow-up-right-from-square"
    }), m("span", {
      className: "FeedbackItem-discussionLinkText"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.discussion_link')), m("span", {
      className: "FeedbackItem-discussionLinkTextShort"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.discussion_link_short')));
  }
  renderActions(feedback, fromUserId) {
    const currentUser = app.session.user;
    if (!currentUser) return null;
    const attrs = feedback.attributes;
    const canReport = attrs.canReport === true;
    const canDelete = attrs.canDelete === true;
    const isOwn = currentUser.id() === String(fromUserId);
    if (!canReport && !canDelete) {
      return null;
    }
    return m("div", {
      className: "FeedbackItem-actions"
    }, !isOwn && canReport && m(Button, {
      className: "Button Button--link FeedbackItem-reportBtn",
      icon: "fas fa-flag",
      onclick: () => this.attrs.onReport(feedback),
      title: app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.report_button')
    }, m("span", {
      className: "FeedbackItem-actionText"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.report_button'))), canDelete && m(Button, {
      className: "Button Button--link Button--danger FeedbackItem-deleteBtn",
      icon: "fas fa-trash",
      onclick: () => this.attrs.onDelete(feedback),
      title: app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.delete_button')
    }, m("span", {
      className: "FeedbackItem-actionText"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.delete_button'))));
  }
}
flarum.reg.add('huseyinfiliz-traderfeedback', 'forum/components/TraderFeedback/FeedbackItem', FeedbackItem);